import LogIcon from '@material-ui/icons/PlaylistPlay';
import ErrorLogList from './errorLogList.js';

export default {
    icon: LogIcon,
    list: ErrorLogList,
};